import React from "react";
import {
  Typography,
  Box,
} from "@mui/material";

// ==============================================
// COMPONENTE PRINCIPAL DE LA SECCIÓN
// ==============================================

const processLinksInHTML = (html) => {
    if (!html) return "";
    
    return html.replace(
      /<a\s+[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/gi,
      (match, url, content) => {
        // Si la URL no tiene protocolo, agregar https://
        const processedUrl = url.match(/^https?:\/\//) ? url : `https://${url}`;
        
        return `<a href="${processedUrl}" target="_blank" rel="noopener noreferrer">${content}</a>`;
      }
    );
  };

function SeccionSobreMi({ profesionalInfo }) {
  const renderProfesionalDescription = () => {
    if (profesionalInfo?.perfil?.profesional_descripcion_html) {
      return (
        <Box
          sx={{
            fontFamily: "Quicksand-Regular",
            fontSize: { xs: "14px", md: "16px" },
            color: "#09090a",
            lineHeight: '1.5',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            textAlign: 'left',
            // ESTILOS PARA ELEMENTOS HTML
            '& p': {
              margin: '8px 0',
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
              '&:first-of-type': {
                marginTop: '0',
              },
              '&:last-of-type': {
                marginBottom: '0',
              }
            },
            '& ol': {
              margin: '8px 0',
              paddingLeft: '20px',
              listStyleType: 'decimal',
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
            },
            '& ul': {
              margin: '8px 0',
              paddingLeft: '20px',
              listStyleType: 'disc',
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
            },
            '& li': {
              margin: '4px 0',
              lineHeight: '1.4',
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
            },
            '& a': {
              color: '#1976D2',
              textDecoration: 'underline',
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
              '&:hover': {
                color: '#115293',
                textDecoration: 'underline',
              },
              '&:visited': {
                color: '#115293',
              }
            },
            '& strong': {
              fontWeight: 'bold',
              fontFamily: "Quicksand-Bold",
              fontSize: { xs: "14px", md: "16px" },
            },
            '& em': {
              fontStyle: 'italic',
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
            },
            '& u': {
              textDecoration: 'underline',
              fontFamily: "Quicksand-Regular",
              fontSize: { xs: "14px", md: "16px" },
            }
          }}
          dangerouslySetInnerHTML={{ 
            __html: processLinksInHTML(profesionalInfo.perfil.profesional_descripcion_html || "")
          }}
        />
      );
    }

    return (
      <Typography sx={{ fontFamily: "Quicksand-Regular", fontSize: { md: "16px", xs: "14px" }, mb: 0 }}>
        No se encontró información del profesional.
      </Typography>
    );
  };

  return (
    <>
      {/* 2. SOBRE MÍ */}
      <Typography
        sx={{
          mb: 1.5,
          mt: 1.5,
          fontFamily: "Quicksand-Bold",
          fontSize: { md: "20px", xs: "18px" },
        }}
      >
        Sobre mí
      </Typography>
      {renderProfesionalDescription()}
    </>
  );
}

export default SeccionSobreMi;
